var _g, _g2, _title;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenAiExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "file_type_excel2")), /*#__PURE__*/React.createElement("path", {
    d: "M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z",
    style: {
      fill: "#20744a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.487,
    y: 7.439,
    width: 4.323,
    height: 2.2,
    style: {
      fill: "#20744a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.487,
    y: 10.94,
    width: 4.323,
    height: 2.2,
    style: {
      fill: "#20744a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.487,
    y: 14.441,
    width: 4.323,
    height: 2.2,
    style: {
      fill: "#20744a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.487,
    y: 17.942,
    width: 4.323,
    height: 2.2,
    style: {
      fill: "#20744a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.487,
    y: 21.443,
    width: 4.323,
    height: 2.2,
    style: {
      fill: "#20744a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenAiExcelIcon);
export default __webpack_public_path__ + "static/media/GenAiExcelIcon.852486e150b379b2b28d25f1413804eb.svg";
export { ForwardRef as ReactComponent };